export const followup = {
    REQUEST:                      'website/followup/REQUEST',
    RECEIVE:                      'website/followup/RECEIVE',
    SEND_INSTANT_MESSAGE_SUCCESS: 'website/followup/SEND_INSTANT_MESSAGE_SUCCESS',
    SHOW_ACCEPT_QUOTATION:        'website/followup/SHOW_ACCEPT_QUOTATION',
    CANCEL_ACCEPT_QUOTATION:      'website/followup/CANCEL_ACCEPT_QUOTATION',
    ACCEPT_QUOTATION:             'website/followup/ACCEPT_QUOTATION',
    ACCEPT_QUOTATION_SUCCESS:     'website/followup/ACCEPT_QUOTATION_SUCCESS',
    ACCEPT_QUOTATION_FAILURE:     'website/followup/ACCEPT_QUOTATION_FAILURE',
    DELETE_DRAFT:                 'website/followup/DELETE_DRAFT',
    DELETE_DRAFT_SUCCESS:         'website/followup/DELETE_DRAFT_SUCCESS',
    DELETE_DRAFT_FAILURE:         'website/followup/DELETE_DRAFT_FAILURE',
    SHOW_PAY:                     'website/followup/SHOW_PAY',
    CHOOSE_PAYMENT_METHOD:        'website/followup/CHOOSE_PAYMENT_METHOD',
    REQUEST_CREDIT_CARD_FIELDS:   'website/followup/REQUEST_CREDIT_CARD_FIELDS',
    RECEIVE_CREDIT_CARD_FIELDS:   'website/followup/RECEIVE_CREDIT_CARD_FIELDS',
    PAYMENT_SUCCESS:              'website/followup/PAYMENT_SUCCESS',
    PAYMENT_FAILURE:              'website/followup/PAYMENT_FAILURE',
    CANCEL_ALL:                   'website/followup/CANCEL_ALL',
    CANCEL_ACTION:                'website/followup/CANCEL_ACTION',
    FAILURE_CANCEL:               'website/followup/FAILURE_CANCEL',
    SUCCESS_CANCEL:               'website/followup/SUCCESS_CANCEL',
    SUBMIT_UPDATE_CANCELLATION:                     'website/followup/SUBMIT_UPDATE_CANCELLATION',
    SUBMIT_UPDATE_CANCELLATION_SUCCESS:             'website/followup/SUBMIT_UPDATE_CANCELLATION_SUCCESS',
    SUBMIT_UPDATE_CANCELLATION_FAILURE:             'website/followup/SUBMIT_UPDATE_CANCELLATION_FAILURE',
};

